import * as React from "react";
import { FunctionComponent } from "react";
import "./EmptyState.css";

export interface Props {
  title: string;
  description: string;
  svg: React.ComponentType<{
    width: number;
    height: number;
  }>;
}

const EmptyState: FunctionComponent<Props> = (props: Props) => {
  const { title, description } = props;

  return (
    <>
      <div className="empty-state-picture">
        <props.svg width={64} height={64}></props.svg>
      </div>
      <div className="empty-state-title">{title}</div>
      <div className="empty-state-description">{description}</div>
    </>
  );
};

export default EmptyState;
